
  import createMeisterIcons from '../src/createMeisterIcons';

  const NoEntry = createMeisterIcons("no-entry", [["path",{"fill":"currentColor","d":"M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12","key":"d174c40d08d8f5f7786f13ab24579b9e546bce64","fillRule":"evenodd","clipRule":"evenodd"}],["path",{"fill":"currentColor","d":"m5.57 18.27 12.7-12.7 1.06 1.06-12.7 12.7z","key":"4b05b5074d49285fa5fe29f1b2efbbd08a8ccbe9","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default NoEntry
  